import {
  secureRandom,
  validateSchemaWithAJV,
} from "../../../../../../utils/commons";

export const getListStyle = (isDraggingOver) => ({
  background: isDraggingOver ? "#e9ebf0" : "#fff",
  width: "100%",
  position: "relative",
});

export const stopPropagation = (e) => {
  e.stopPropagation();
};

export function handleOnDragEnd(result, list = []) {
  if (!result.destination) return;
  const newValue = Array.from(list);
  const [draggedItem] = newValue.splice(result.source.index, 1);
  newValue.splice(result.destination.index, 0, draggedItem);
  return newValue;
}

/**
 * Creates a filter object for rewards based on catalog IDs and search text
 * @param {string} searchText - Text to search for in reward names
 * @param {Array} selectedCatalogIds - Array of selected catalog IDs
 * @param {Array} allCatalogs - Array of all available catalogs
 * @returns {Object|null} Filter object or null if no catalogs are available
 */
export const createRewardsFilter = (
  searchText,
  selectedCatalogIds = [],
  allCatalogs = []
) => {
  const catalogIds =
    selectedCatalogIds.length > 0
      ? selectedCatalogIds.map((selected) => selected.id)
      : allCatalogs?.map((c) => c.catalogId) || [];

  if (!catalogIds.length) return null;

  return {
    isActive: true,
    catalogs: catalogIds,
    ...(searchText && { name: searchText }),
  };
};

/**
 * Toggle a reward in the selected rewards list
 * @param {Object} reward - The reward to toggle
 * @param {Array} currentRewards - The current list of rewards
 * @returns {Array} Updated list of rewards
 */
export const toggleReward = (reward, currentRewards = []) => {
  const rewardId = reward.id || reward.reward_id;
  const exists = currentRewards.find(
    (r) => r.reward_id === rewardId || r.reward_id === reward.reward_id
  );

  if (exists) {
    return currentRewards.filter(
      (r) => r.reward_id !== rewardId && r.reward_id !== reward.reward_id
    );
  }

  const instanceId = `${rewardId}_${Date.now()}_${secureRandom()}`;

  return [
    ...currentRewards,
    {
      reward_name: reward.name,
      total_quantity: reward.quantity,
      image_url: reward.imageUrl,
      reward_id: rewardId,
      catalog_id: reward.catalogId,
      instanceId,
      reward_unit_id: reward.rewardUnitId,
      rank_range: {
        from: "",
        to: "",
      },
    },
  ];
};

/**
 * Maps catalog items to dropdown format
 * @param {Array} catalogItems - The catalog items from API response
 * @returns {Array} - Formatted catalog items for dropdown
 */
export const formatCatalogsForDisplay = (catalogItems) => {
  if (!catalogItems?.length) return [];

  return catalogItems.map((item) => ({
    displayText: item.catalogName,
    id: item.catalogId,
  }));
};

export const customValidationWithMessage = (slug, schema, data) => {
  const isValid = validateSchemaWithAJV(schema, data);
  if (isValid) {
    return { isValid: true, message: "" }; // Return true if validation passes
  } else {
    if (slug === "award-leaderboard-points") {
      if (data && data.leaderboard_id?.length > 0)
        return { isValid: true, message: "" };
      return { isValid: false, message: "Please select atleast one leaderboard." };
    } else if (slug === "allocate-campaign-current-points") {
      return { isValid: false, message: "Please select atleast one reward." };
    }
    return {
      isValid: false,
      message: "Please ensure all required fields are filled out correctly.",
    };
  }
};
